import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ClientsNotInConfigurationTableReportCriteria extends ValueObject  
{
    public staticServiceProviderFileGroupingId: number = 0;

    public serviceProviderGroupingName: string = "";
}